import { HEAD_ELEMENT_INDEX } from './const.js';
import { isEmpty } from './is-empty.js';

export function getHeadElement<T>(array: T[]): Nullable<T> {
  if (isEmpty(array)) {
    return null;
  }

  return array[HEAD_ELEMENT_INDEX];
}
